<template>
  <div id="app">
    <!-- 网站盒子 -->
    <div class="pcBox">
      <!-- 页面容器 -->
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style >
.inp .el-input__inner{
    height: 51px!important;
    line-height: 51px!important;
}
 #card .el-carousel__item{
    width: 872px!important;
  }
  
  #card .el-carousel__item--card.is-active {
    z-index: 2!important;
    position: relative!important;
    left: -120px!important;
}

#card .el-carousel__item--card.is-in-stage {
    cursor: pointer;
    z-index: 1;
    position: absolute!important;
    left: -153px!important;
}
/* 全局样式 */
body {
  margin: 0px;
}
#app {
  margin: 0 auto;
  padding: 0px;
}
.pcBox {
  width: 1920px !important;
  min-width: 1200px !important;
  margin: 0 auto;
}

#card .el-carousel__item .is-active{
  transform: translateX(171px) scale(1)!important;
}
.headbox .el-menu .el-menu--inline{
background: #fff!important;
}
.pag .el-pagination button, .el-pagination span:not([class*=suffix]) {
    display: inline-block;
    font-size: 13px;
    min-width: 65.5px!important;
    height: 28px;
    line-height: 28px;
    vertical-align: top;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
#card .el-carousel__item .is-active .el-carousel__item--card .is-in-stage{
      transform: translateX(164.5px) scale(1)!important;
    width: 100% !important;
    height: 400px !important;
}
</style>




// WEBPACK FOOTER //
// src/App.vue